const BASEURL = import.meta.env.VITE_API_BASEURL as string;

/** Check whether the rewards feed has at least one available record. */
export const hasRewardsData = async (): Promise<boolean> => {
  try {
    const response = await fetch(`${BASEURL}/ripcityrewards`);

    if (!response.ok) return false;

    const data = await response.json();
    return getFirstRecord(data) !== undefined;
  } catch {
    return false;
  }
};

/** Normalize API response so Home always receives tbURL and rqURL. */
function normalizeLinksResponse(raw: Record<string, unknown> | undefined) {
  if (!raw) return undefined;
  const singleUrl =
    (raw.URL as string) ??
    (raw.Url as string) ??
    (raw.url as string) ??
    (raw.tbURL as string) ??
    (raw.tb_url as string) ??
    (raw.rqURL as string) ??
    (raw.rq_url as string);
  const tbURL = (raw.tbURL as string) ?? (raw.tb_url as string) ?? singleUrl;
  const rqURL = (raw.rqURL as string) ?? (raw.rq_url as string) ?? singleUrl;
  return {
    ...raw,
    GroupCode: raw.GroupCode ?? raw.group_code,
    tbURL,
    rqURL,
  };
}

/** Get first reward record from API response (array, or { data/result: array | object }, or single object). */
function getFirstRecord(data: unknown): Record<string, unknown> | undefined {
  if (!data || typeof data !== "object") return undefined;
  if (Array.isArray(data) && data.length > 0) return data[0] as Record<string, unknown>;
  const obj = data as Record<string, unknown>;
  for (const key of ["data", "result", "payload"]) {
    const inner = obj[key];
    if (Array.isArray(inner) && inner.length > 0) return inner[0] as Record<string, unknown>;
    if (inner != null && typeof inner === "object" && !Array.isArray(inner))
      return inner as Record<string, unknown>;
  }
  if (obj.URL != null || obj.url != null || obj.GroupCode != null || obj.group_code != null)
    return obj;
  return undefined;
}

export const getLinks = async (
  code: string,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
  try {
    const response = await fetch(`${BASEURL}/ripcityrewards/${encodeURIComponent(code)}`);

    setLoading(false);

    if (response.status !== 200) return undefined;

    const data = await response.json();
    const first = getFirstRecord(data);
    const normalized = normalizeLinksResponse(first);
    if (normalized && (normalized.tbURL || normalized.rqURL)) return normalized;
    return undefined;
  } catch {
    setLoading(false);
    return undefined;
  }
};
